if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        // The product page HTML is reused inside quick add modals; no sticky bar there.
        if (this.closest('quick-add-modal, modal-dialog')) {
          this.remove();
          return;
        }

        // Ancestors with transforms (e.g. scroll animations) would trap position: fixed inside the section,
        // so the bar lives directly in <body>. Moving it reconnects the element, which then runs the setup below.
        if (this.parentElement !== document.body) {
          document
            .querySelectorAll(`body > sticky-atc[data-button-id="${this.dataset.buttonId}"]`)
            .forEach((bar) => bar.remove());
          document.body.appendChild(this);
          return;
        }

        this.button = this.querySelector('.sticky-atc__button');
        this.label = this.querySelector('.sticky-atc__label');
        this.spinner = this.button.querySelector('.loading__spinner');
        this.button.addEventListener('click', () => this.mainButton?.click());

        this.intersection = new IntersectionObserver(([entry]) => {
          // Only show once the main button has been scrolled past (it is above the viewport).
          this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.mutation = new MutationObserver(() => this.sync());

        this.onSectionUnload = (event) => {
          if (this.dataset.buttonId === `ProductSubmitButton-${event.detail.sectionId}`) this.remove();
        };
        document.addEventListener('shopify:section:unload', this.onSectionUnload);

        this.attach();
      }

      disconnectedCallback() {
        this.intersection?.disconnect();
        this.mutation?.disconnect();
        if (this.onSectionUnload) document.removeEventListener('shopify:section:unload', this.onSectionUnload);
        document.body.classList.remove('sticky-atc-visible');
      }

      attach() {
        const button = document.getElementById(this.dataset.buttonId);
        this.intersection.disconnect();
        this.mutation.disconnect();
        this.mainButton = button;

        if (!button) {
          this.toggle(false);
          return;
        }

        this.intersection.observe(button);
        this.mutation.observe(button, {
          attributes: true,
          attributeFilter: ['disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        this.sync();
      }

      // Mirror the main button: disabled/sold out state, label and loading spinner.
      sync() {
        if (!this.mainButton?.isConnected) return this.attach();

        const loading = this.mainButton.classList.contains('loading');
        const text = this.mainButton.querySelector('span')?.textContent.trim();

        this.button.disabled = this.mainButton.disabled;
        this.button.classList.toggle('loading', loading);
        this.spinner?.classList.toggle('hidden', !loading);
        if (text) this.label.textContent = text;
      }

      toggle(visible) {
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        document.body.classList.toggle('sticky-atc-visible', visible);
      }
    }
  );
}
